// Third-party
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

// Components
import NoDataCell from './NoDataCell';

// Utils
import { formatMessage } from '../../../utils/i18n';

type Props = {
  value?: string;
  className?: string;
  disclaimer?: string;
  onClick?: () => void;
  id?: string;
  format?: string;
};

const DateCell: React.FunctionComponent<Props> = ({ value, className, disclaimer, onClick, id, format }: Props) => {
  if (value == null) {
    return <NoDataCell onClick={onClick} id={id} disclaimerKey={disclaimer} />;
  }

  return (
    <div className={classNames('cell date-cell', className)} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">{moment.utc(value).format(format || formatMessage('Common.DateFormats.Short'))}</span>
    </div>
  );
};

export default DateCell;
